import { Condition } from "@redotech/redo-model/return-flow/condition";
import {
  finalSaleReturnFromModel,
  validateFinalSaleReturnCondition,
  type FinalSaleReturnState,
} from "@redotech/redo-model/return-flow/condition-validate";
import * as React from "react";
import { ConditionType, ConditionTypeDetailsProps } from "../condition";

export const FINAL_SALE_RETURN = (
  Details: React.ComponentType<ConditionTypeDetailsProps<FinalSaleReturnState>>,
): ConditionType<FinalSaleReturnState, Condition.FinalSaleReturn> => ({
  name: "Final sale return item",
  description(state) {
    return "Item is a final sale return";
  },
  Details(props: ConditionTypeDetailsProps<FinalSaleReturnState>) {
    return React.createElement(Details, props);
  },
  empty: { validCollections: [], validProductTags: [] },
  fromModel(model) {
    return finalSaleReturnFromModel(model);
  },
  toModel(state) {
    return {
      type: Condition.FINAL_SALE_RETURN,
      validCollections: state.validCollections,
      validProductTags: state.validProductTags,
    };
  },
  valid(state) {
    return validateFinalSaleReturnCondition(state).valid;
  },
});

export { type FinalSaleReturnState } from "@redotech/redo-model/return-flow/condition-validate";
